export const LIST = 'list';
export const Bronze = 'Bronze';
export const Silver = 'Argent';
export const Gold = 'Or';
export const Platinum = 'Platine';
export const Ruby = 'Rubis';
export const EMERALD = 'emerald';
export const Diamond = 'Diamant';
